import { atom } from 'jotai';

export type ToastVariant = 'success' | 'error' | 'info';

export interface ToastMessage {
  id?: string;
  message: string;
  variant: ToastVariant;
}

export const toastsAtom = atom<ToastMessage[]>([]);